import type { IconSvgObject } from './types';

const File01Icon: IconSvgObject = [
  ["path", { d: "M7.99976 7H15.9998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.99976 11H11.9998", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.9955 22.0015H6C4.89421 22.0015 3.99828 21.1042 4 19.9984L4.02496 3.99688C4.02668 2.89353 4.92161 2 6.02496 2H17.9969C19.1014 2 19.9969 2.89543 19.9969 4V15.0145L12.9955 22.0015Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M20 15H15C13.8954 15 13 15.8954 13 17V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default File01Icon;
